export const SEX_LABELS = {
  0: "Male",
  1: "Female"
};

export const ETHNICITY_LABELS = {
  0: "White",
  1: "Black or African American",
  2: "Asian",
  3: "American Indian or Alaska Native",
  4: "Native Hawaiian or Other Pacific Islander"
};
